export const getSections = ({isCoach, ts}: any) => {
  const sections = [
    {
      icon: 'timer-start',
      title: ts('immediate.title', 'Immediate Metrics'),
      subhead: ts(
        'immediate.subhead',
        'Delay up to 10 minutes. Database updated continually.',
      ),
      items: [
        ts('immediate.currentVolume', 'Current Month Volumes'),
        ts('immediate.clientCoachCounts', 'Client, and Coach Counts'),
        ts('immediate.earningsCommissions', 'Earnings and Commissions'),
        ts('immediate.qualifyingPoints', 'Qualifying Points'),
      ],
    },
    {
      icon: 'timer-end',
      title: ts('computed.title', 'Computed Metrics'),
      subhead: ts('computed.subhead', 'Database updated every hour.'),
      items: [
        ts('computed.projected', 'Projected Volumes'),
        ts('computed.orderCount', 'Order Counts'),
      ],
    },
  ];

  if (!isCoach) {
    // Immediate Metrics
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    sections[0].items.push(ts('immediate.teamCounts', 'Team Counts'));

    // Computed Metrics
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    sections[1].items.push(ts('computed.rankCounts', 'Rank Counts'));
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    sections[1].items.push(ts('computed.qsbCab', 'Eligible for QSB and CAB'));
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    sections[1].items.push(
      ts('computed.expiringRenewals', 'Expiring Coach Renewals'),
    );
  }

  return sections;
};
